export var countryListMapper = function (apiData) {
    var _a;
    var response = {
        data: {
            countryCodeList: [],
            countryLabel: {},
            countryData: apiData === null || apiData === void 0 ? void 0 : apiData.data,
        },
    };
    if (apiData.data && ((_a = apiData === null || apiData === void 0 ? void 0 : apiData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        apiData.data.map(function (record) {
            var _a, _b;
            (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.countryCodeList) === null || _b === void 0 ? void 0 : _b.push(record === null || record === void 0 ? void 0 : record.country_s_code);
            response.data.countryLabel[record === null || record === void 0 ? void 0 : record.country_s_code] = {
                primary: record === null || record === void 0 ? void 0 : record.country_name,
                secondary: "(+".concat(record === null || record === void 0 ? void 0 : record.country_suffix, ")"),
            };
        });
    }
    return response;
};
